import LoginFromStore from './components/Login/mobx'
import OrderStore from './components/Order/mobx'
import SettingsStore from './components/Settings/mobx'
import HistoryStore from './components/History/mobx'
import TemplatesStore from './components/Templates/mobx'
import MapStore from './components/Map/mobx'
import NotificationsStore from './components/Notifications/mobx'

export const loginStore = LoginFromStore

export default {
  LoginFromStore,
  OrderStore,
  SettingsStore,
  HistoryStore,
  TemplatesStore,
  MapStore,
  NotificationsStore,
};
